/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleProfile
 */
export interface VehicleProfile {
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleProfile
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleProfile
     */
    euroClass?: VehicleProfileEuroClassEnum;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    numberOfAxles?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    weight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    pricePerKm: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    trailersCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    width?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    length?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleProfile
     */
    tunnel?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProfile
     */
    isDefault?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleProfile
     */
    client: number;
}

export function VehicleProfileFromJSON(json: any): VehicleProfile {
    return VehicleProfileFromJSONTyped(json, false);
}

export function VehicleProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'euroClass': !exists(json, 'euro_class') ? undefined : json['euro_class'],
        'numberOfAxles': !exists(json, 'number_of_axles') ? undefined : json['number_of_axles'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'pricePerKm': json['price_per_km'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'trailersCount': !exists(json, 'trailers_count') ? undefined : json['trailers_count'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'tunnel': !exists(json, 'tunnel') ? undefined : json['tunnel'],
        'isDefault': !exists(json, 'is_default') ? undefined : json['is_default'],
        'client': json['client'],
    };
}

export function VehicleProfileToJSON(value?: VehicleProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'euro_class': value.euroClass,
        'number_of_axles': value.numberOfAxles,
        'weight': value.weight,
        'price_per_km': value.pricePerKm,
        'height': value.height,
        'trailers_count': value.trailersCount,
        'width': value.width,
        'length': value.length,
        'tunnel': value.tunnel,
        'is_default': value.isDefault,
        'client': value.client,
    };
}

/**
* @export
* @enum {string}
*/
export enum VehicleProfileEuroClassEnum {
    None = 'None',
    EEV = 'EEV',
    EUROI = 'EURO_I',
    EUROII = 'EURO_II',
    EUROIII = 'EURO_III',
    EUROIV = 'EURO_IV',
    EUROV = 'EURO_V',
    EUROVI = 'EURO_VI'
}


